module.exports = __webpack_public_path__ + "static/media/email.5f0b954a.svg";